import React from 'react';
import '../styles/AboutSection.css';
import p1 from '../assets/pest.png';

const AboutSection = () => {
  const values = [
    {
      id: 1,
      icon: '🔒',
      title: 'Trust & Integrity',
      description: 'We believe in honest communication and transparent pricing with no hidden fees.'
    },
    {
      id: 2,
      icon: '🌿',
      title: 'Eco-Friendly Approach',
      description: 'Our treatments are safe for your family, pets, and the environment.'
    },
    {
      id: 3,
      icon: '🎯',
      title: 'Excellence in Service',
      description: 'We go above and beyond to ensure every customer is completely satisfied.'
    },
    {
      id: 4,
      icon: '🤝',
      title: 'Community Commitment',
      description: 'We\'re proud to serve our local communities with dedication and care.'
    }
  ];

  const handleLearnMore = () => {
    window.location.href = 'tel:+18334936242';
  };

  return (
    <section className="abt-section" id="about">
      <div className="abt-container">
        {/* Section Header */}
        <div className="abt-header">
          <span className="abt-tag">About Us</span>
          <h2 className="abt-title">Protecting Homes & Businesses Since 2003</h2>
          <p className="abt-subtitle">
            We're a family-owned pest control company dedicated to providing safe, effective, 
            and reliable pest management solutions across the United States.
          </p>
        </div>

        {/* About Content */}
        <div className="abt-content">
          <div className="abt-text">
            <div className="abt-text-content">
              <h3 className="abt-text-title">Your Trusted Pest Control Partner</h3>
              <p className="abt-text-paragraph">
                At PestControl Today, we understand that pest problems can be stressful and overwhelming. 
                That's why we're committed to delivering fast, effective, and long-lasting solutions that 
                give you peace of mind.
              </p>
              <p className="abt-text-paragraph">
                With over 20 years of experience in the industry, our team of certified professionals 
                uses the latest techniques and eco-friendly products to eliminate pests and prevent 
                future infestations. We treat every home and business as if it were our own, ensuring 
                the highest level of care and attention to detail.
              </p>
              <div className="abt-features">
                <div className="abt-feature">
                  <span className="abt-feature-icon">✓</span>
                  <span>Licensed & Insured Professionals</span>
                </div>
                <div className="abt-feature">
                  <span className="abt-feature-icon">✓</span>
                  <span>Same-Day Service Available</span>
                </div>
                <div className="abt-feature">
                  <span className="abt-feature-icon">✓</span>
                  <span>100% Satisfaction Guarantee</span>
                </div>
                <div className="abt-feature">
                  <span className="abt-feature-icon">✓</span>
                  <span>Free Inspections & Estimates</span>
                </div>
              </div>
              <button className="abt-btn" onClick={handleLearnMore}>
                📞 Call Now: +1 (833) 493-6242 →
              </button>
            </div>
          </div>
          <div className="abt-image">
            <div className="abt-image-wrapper">
              <img 
                src={p1} 
                alt="Pest Control Professionals at work"
                className="abt-image-img"
                loading="lazy"
              />
              <div className="abt-image-overlay">
                <span className="abt-overlay-icon">🐜</span>
                <p className="abt-overlay-text">Professional Pest Control Services</p>
              </div>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="abt-values">
          <h3 className="abt-values-title">Our Core Values</h3>
          <div className="abt-values-grid">
            {values.map((value) => (
              <div className="abt-value-card" key={value.id}>
                <div className="abt-value-icon">{value.icon}</div>
                <h4 className="abt-value-title">{value.title}</h4>
                <p className="abt-value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;